export default __webpack_public_path__ + "static/media/forestly-expl-dissect-intro_DE.49f087f7.png";